// src/modules/app-views/products/pages/Init/components/tableColumns/ncmColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function ncmColumn(buildColumnProps, options = {}) {
  const {
    key = 'ncm',
    title = 'ncm',
    dataIndex = ['fiscalData', 'ncm'],
    width = 120,
    columnProps = { sort: true, search: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    ...buildColumnProps('fiscalData.ncm', columnProps),
    render: (_, r) => r?.fiscalData?.ncm || '—',
  };
}

export default ncmColumn;
